import React from "react"
import {Grid} from "@mui/material";



interface Props {
    left?: JSX.Element|JSX.Element[] | undefined;
    right?: JSX.Element|JSX.Element[];
    margin?: number
}

function CCOContainer33_66(props: Props) {
    return <>
        <Grid container margin={props.margin ?? 0}
              paddingY={'0!important'}
              sx={{
                ':hover h6': {
                    color: 'primary.main'
                },
              ':hover .MuiTypography-linkLabel': {
                  textDecoration: 'underline'
              }
              }}>
            {props.left ? <Grid item xs={12} md={4} display={'flex'} alignItems={'top'} justifyItems={'center'}
                   justifyContent={'center'} paddingTop={6} paddingBottom={{md: 6, xs: 0}} paddingLeft={{md: 4, xs: 0}}>
                {props.left}
            </Grid> : null}
            <Grid item xs={12} md={props.left ? 8 : 12} display={'flex'} flexDirection={'column'} alignItems={'top'}
                  justifyItems={'center'} paddingY={6} paddingLeft={{md: props.left ? 6 : 4, xs: 4}} paddingRight={4}>
                {props.right}
            </Grid>
        </Grid>
    </>
}



export default CCOContainer33_66